import { Message } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import Form from "../../../../forms/components/Form/Form";
import Table from "../../../../ui/components/Table/Table";

import useSecondaryAgreementParties from "../../../hooks/useSecondaryAgreementParties";

import useSecondaryPartiesColumns from "../hooks/useSecondaryPartiesColumns";

function SecondaryPartiesTable({ part, value, firstParty, error, onChange }) {
	const { t } = useTranslation();

	const { watch } = Form.useFormContext();
	const secondaryPartiesColumns = useSecondaryPartiesColumns({ part, signed: watch("signed") });
	const secondaryParties = useSecondaryAgreementParties({ part, firstPartyId: firstParty.id });

	if (secondaryParties.length === 0) {
		return t("noPartiesFound", "No parties found");
	}

	return (
		<>
			<Table
				data={secondaryParties}
				footer={false}
				columns={secondaryPartiesColumns}
				sortable
				selectable
				filterable
				pagination
				sortBy={{ id: "name", desc: false }}
				initialState={{
					pageSize: 10,
					selectedRowIds: Object.keys(value).reduce(
						(acc, key) => ({
							...acc,
							[key]: true,
						}),
						{},
					),
				}}
				onSelectRows={(parties) =>
					onChange(null, {
						value: parties.reduce(
							(map, party) => ({
								...map,
								[party.rowId]: party,
							}),
							{},
						),
					})
				}
			/>

			{error?.content && <Message negative size="small" content={error.content} />}
		</>
	);
}

export default function SecondaryParties({ part, firstParty, multiple = true }) {
	const { t } = useTranslation();

	// A returned string is shown under the table.
	const validate = (value) => {
		const parties = Object.values(value);

		if (parties.length === 0) {
			return t("selectAtLeastOneParty", "Select at least one party");
		}

		// One signed file is for one party.
		if (!multiple && parties.length > 1) {
			return t("signedAgreementOneParty", "A signed agreement can only have one party");
		}

		// Signees are not checked here: each SigneeSelect is a required field and shows its own error.
		return true;
	};

	return (
		<Form.Field name="parties" rules={{ validate }}>
			<SecondaryPartiesTable part={part} firstParty={firstParty} />
		</Form.Field>
	);
}
